import { render } from "./PlayerSetup.vue?vue&type=template&id=72885923&scoped=true"
import script from "./PlayerSetup.vue?vue&type=script&lang=js"
export * from "./PlayerSetup.vue?vue&type=script&lang=js"

import "./PlayerSetup.vue?vue&type=style&index=0&id=72885923&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72885923"]])

export default __exports__